import { FC } from 'react';
import moment from 'moment';
import i18next from 'i18next';

interface OwnProps {
  t: i18next.TFunction;
  withDot?: boolean;
  date?: string;
  textKey?: string;
}

const DaysLeft: FC<OwnProps> = ({ withDot = false, date = null, textKey = 'x.sidebar.subnav.surveys.daysleft', t }) => {
  if (moment(`${date} 23:59:59`).isBefore(new Date())) {
    return (
      <span data-translation="x.days_left.overdue">
        <span>{withDot && '• '}</span>
        {t('x.days_left.overdue')}
      </span>
    );
  }
  return (
    <span style={{ marginLeft: '.2rem' }}>
      <span>
        <span>{withDot && '• '}</span>
        {date && moment(date).add(1, 'days').fromNow(true)}
      </span>
      <span data-translation={textKey}>{` ${textKey && t(textKey)}`}</span>
    </span>
  );
};

export default DaysLeft;
